/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface AnchorageCallsGet200ResponseRecordsInner
 */
export interface AnchorageCallsGet200ResponseRecordsInner {
    /**
     * 
     * @type {Ship}
     * @memberof AnchorageCallsGet200ResponseRecordsInner
     */
    ship?: Ship;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnchorageCallsGet200ResponseRecordsInner
     */
    locodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AnchorageCallsGet200ResponseRecordsInner
     */
    anchorage?: string;
    /**
     * 
     * @type {Date}
     * @memberof AnchorageCallsGet200ResponseRecordsInner
     */
    ata?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AnchorageCallsGet200ResponseRecordsInner
     */
    atd?: Date;
}

/**
 * Check if a given object implements the AnchorageCallsGet200ResponseRecordsInner interface.
 */
export function instanceOfAnchorageCallsGet200ResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnchorageCallsGet200ResponseRecordsInnerFromJSON(json: any): AnchorageCallsGet200ResponseRecordsInner {
    return AnchorageCallsGet200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function AnchorageCallsGet200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnchorageCallsGet200ResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'locodes': !exists(json, 'locodes') ? undefined : json['locodes'],
        'anchorage': !exists(json, 'anchorage') ? undefined : json['anchorage'],
        'ata': !exists(json, 'ata') ? undefined : (new Date(json['ata'])),
        'atd': !exists(json, 'atd') ? undefined : (new Date(json['atd'])),
    };
}

export function AnchorageCallsGet200ResponseRecordsInnerToJSON(value?: AnchorageCallsGet200ResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
        'locodes': value.locodes,
        'anchorage': value.anchorage,
        'ata': value.ata === undefined ? undefined : (value.ata.toISOString()),
        'atd': value.atd === undefined ? undefined : (value.atd.toISOString()),
    };
}

